import ViolationsTabFooter from './ViolationsTabFooter';

export default ViolationsTabFooter;
